import { Autocomplete, Chip } from "@mui/material";

import Helpers from "../../commons/helpers";
import { Mode } from "../../constants/enums";
import TextField from "../TextField";
import TitleValue from "../TitleValue";

interface IProps {
    size?: any;
    variant?: any;
    mode?: Mode;
    label?: string;
    placeholder?: string;

    disabled?: boolean;
    isFullRow?: boolean;
    required?: boolean;
    readOnly?: boolean;
    errorMessage?: string;
    maxEmails?: number;
    value: string[];
    onChangeValue: (value: string[]) => void;
}

const EmailInput: React.FC<IProps> = ({
    value,
    onChangeValue,
    size,
    isFullRow,
    variant,
    mode,
    label,
    placeholder,
    disabled,
    errorMessage,
    required,
    readOnly,
    maxEmails,
}) => {
    const getEmailList = (value: string[]) => {
        let emailList: string[] = [];
        emailList = value.join(" ").split(" ");
        const emailListTemp: string[] = [];
        emailList.forEach((item) => {
            if (Helpers.isNullOrEmpty(item)) return;
            const formatedItem = item.replace(",", "").replace(";", "");
            if (Helpers.isValidEmail(formatedItem)) emailListTemp.push(formatedItem);
        });
        return !Helpers.isNullOrEmpty(maxEmails) && maxEmails !== 0 ? emailListTemp.splice(0, maxEmails) : emailListTemp;
    };

    const removeDuplicates = (arr: string[]) => {
        return arr.filter((item, index) => arr.indexOf(item) === index);
    };

    const removeOption = (index: number) => {
        const temp = [...value];
        temp.splice(index, 1);
        onChangeValue(temp);
    };

    if (mode === Mode.View) {
        return <TitleValue title={label} isFullRow={isFullRow} value={value.join(", ")} />;
    }

    return (
        <Autocomplete
            key={value as any}
            clearIcon={false}
            options={[]}
            freeSolo
            multiple
            value={value}
            disabled={disabled}
            readOnly={readOnly}
            renderTags={(value, props) =>
                value.map((option, index) => (
                    <Chip
                        label={option}
                        {...props({ index })}
                        onDelete={() => {
                            removeOption(index);
                        }}
                    />
                ))
            }
            renderInput={(params) => (
                <TextField
                    {...params}
                    // value={valueInput}
                    // onChange={(e: any) => setValueInput(e.target.value)}
                    // defaultValue={valueInput}
                    // onBlur={tagsBlurHandler}

                    label={label}
                    variant={variant}
                    disabled={disabled}
                    required={required}
                    readOnly={readOnly}
                    placeholder={placeholder}
                    helperText={errorMessage}
                    error={!Helpers.isNullOrEmpty(errorMessage)}
                    InputLabelProps={{ shrink: true }}
                />
            )}
            onChange={(value, selectedOption) => {
                const newValue = removeDuplicates(getEmailList(selectedOption));
                onChangeValue(newValue);
            }}
            onBlur={(e: any) => {
                const newValue = [...value, ...removeDuplicates(getEmailList(e.target?.value.split(" ") || ""))];
                onChangeValue(newValue);
            }}
        />
    );
};

export default EmailInput;
